import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/dental/PageHero";
import { SERVICES } from "../data/site";
import Button from "../components/dental/Button";

const DentalServicesPage = () => (
  <>
    <PageHero
      subtitle="Galleria"
      title="Dental Services"
      breadcrumb="Dental Services"
      image=                "https://galleria-dental-media.s3.eu-north-1.amazonaws.com/uploads/gallery/25417933-8789-48ce-a5be-5b22d1835e9b.png"

    />

    <section className="bg-[#FBF8F1] py-20 md:py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <p className="text-[#4E5750]/85 leading-relaxed">
            Comprehensive, leading-edge dentistry delivered with the warmth and comfort of a luxury spa. Every treatment
            is tailored to your goals and your wellbeing.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s) => (
            <Link
              key={s.slug}
              to={`/dental-services/${s.slug}`}
              className="group relative block overflow-hidden bg-[#ffffff] shadow-xl hover:shadow-[0_20px_40px_-10px_rgba(208,191,167,0.4)] transition-all duration-500"
            >
              <div className="absolute inset-0 p-[1px] pointer-events-none z-10">
                <div
                  className="w-full h-full"
                  style={{
                    background: "linear-gradient(180deg, #D8C8A8 0%, #B79A68 40%, #8D7448 100%)",
                    WebkitMask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
                    WebkitMaskComposite: "xor",
                    maskComposite: "exclude",
                    padding: "1px",
                  }}
                />
              </div>
              <div className="relative h-64 overflow-hidden">
                <img src={s.image} alt={s.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1200ms] opacity-90 group-hover:opacity-100" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#FBF8F1] via-[#FBF8F1]/30 to-transparent" />
              </div>
              <div className="relative p-6 text-center">
                <h3 className="font-cinzel text-sm gold-gradient-text uppercase tracking-[0.15em] leading-snug min-h-[44px]">
                  {s.name}
                </h3>
                <p className="text-[#4E5750]/75 text-sm mt-3 leading-relaxed">{s.tagline}</p>
                <div className="flex items-center justify-center gap-2 mt-4">
                  <span className="h-px w-6 bg-[#B79A68]/60" />
                  <span className="text-[#B79A68] text-[10px] uppercase tracking-[0.3em] group-hover:tracking-[0.4em] transition-all">
                    Learn More
                  </span>
                  <span className="h-px w-6 bg-[#d0bfa7]/60" />
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-14">
          <Button to="/contact">Reserve Your Visit</Button>
        </div>
      </div>
    </section>
  </>
);

export default DentalServicesPage;
